import React, { Component } from 'react';
import { notification } from 'antd';
// import { login } from '@/api/user';
import { accountLogin } from '@/api/login';
import { updateCookie } from '../../utils/index';
class AutoLogin extends Component {
    async componentDidMount() {
        const BI = localStorage.getItem('BI');
        let userInfo = { name: 'livestat', password: 'f8EvJhfEbHrJ8ea' };

        if (BI.username && BI.password) {
            userInfo = { name: BI.username, password: BI.password };
        }

        const { success, data, msg } = await accountLogin(userInfo);

        if (success) {
            updateCookie(Object.assign(data, { domain: window.location.host }));
            // localStorage.setItem(
            //     'X-TOKEN',
            //     JSON.stringify({
            //         accessKey: data.accessKey,
            //         secret: data.secretKey,
            //         timestamp: data.timestamp
            //     })
            // );
            if (location.search) {
                let next = location.search.slice(1).split('=')[1];

                window.location.href = next;
            } else {
                window.location.href = '/operate';
            }
        } else {
            notification.error({
                message: '操作异常',
                description: msg || '未知的错误'
            });
        }
    }

    render() {
        return <div>自动登录中...</div>;
    }
}

export default AutoLogin;
